import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTypedTranslation } from '@app/hooks';
import { EmptyTableType } from '@app/componentsV2';
import { TranslationsTypes } from '@app/models';
import { PasslyButton } from '@app/components';

interface IProps {
    // EmptyTableType maps to _emptyTable.scss
    displayType: EmptyTableType;
    primaryText: TranslationsTypes;
    secondaryText: TranslationsTypes;
    primaryButtonCallback?: Function;
    primaryButtonText?: TranslationsTypes;
    secondaryButtonCallback?: Function;
    secondaryButtonText?: TranslationsTypes;
}

export const EmptyTable: React.SFC<IProps> = (props: IProps) => {
    const { displayType, primaryText, secondaryText, primaryButtonCallback, primaryButtonText, secondaryButtonCallback, secondaryButtonText } = props;
    const { translation } = useTypedTranslation();

    return (
        <Grid container direction='column' alignItems='center' justifyContent='center'>
            <Grid container direction='column' alignItems='center' justifyContent='center'>
                <div className={`emptyTable emptyTable-${displayType}`} />
                <Typography variant='h1' color='textSecondary'>
                    {translation(primaryText)}
                </Typography>
                <Typography variant='subtitle1' color='textSecondary'>
                    {translation(secondaryText)}
                </Typography>
            </Grid>

            {/* button actions */}
            <Grid container spacing={5} direction='row' alignItems='center' justifyContent='center'>
                {secondaryButtonText !== undefined && secondaryButtonCallback !== undefined && (
                    <Grid item>
                        <PasslyButton variant='outlined' onClick={() => secondaryButtonCallback()}>
                            {translation(secondaryButtonText)}
                        </PasslyButton>
                    </Grid>
                )}
                {primaryButtonText !== undefined && primaryButtonCallback !== undefined && (
                    <Grid item>
                        <PasslyButton color='primary' variant='contained' onClick={() => primaryButtonCallback()}>
                            {translation(primaryButtonText)}
                        </PasslyButton>
                    </Grid>
                )}
            </Grid>
        </Grid>
    );
};
